import { render, staticRenderFns } from "./sensor.vue?vue&type=template&id=f37c713c&scoped=true&"
import script from "./sensor.vue?vue&type=script&lang=js&"
export * from "./sensor.vue?vue&type=script&lang=js&"
import style0 from "./sensor.vue?vue&type=style&index=0&id=f37c713c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c713c",
  null
  
)

export default component.exports